import React, { useState } from "react";
import { toast } from "sonner";
import { Church, Plus, Check } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { contactsFrom } from "@/components/admin/ContactsEditor";

export function DioceseContacts({ org, canEdit, onAdded }: { org: any; canEdit: boolean; onAdded: () => void }) {
  const [busy, setBusy] = useState("");
  if (!org.dow_contacts?.length && !org.inactive) return null;
  const ours = new Set((org.contacts || []).map((c: any) => (c.email || "").toLowerCase()).filter(Boolean));
  const add = async (c: any) => {
    setBusy(c.email);
    try {
      const existing = contactsFrom(org).filter((x: any) => x.name || x.email);
      const contacts = [...existing, { name: c.name, email: c.email || null, phone: c.phone, role: "other", role_other: "Diocese contact", primary: !existing.length }];
      await api.patch(`/admin/organizations/${org.id}`, { ...org, email: org.email || null, contacts: contacts.map((x: any) => ({ ...x, email: x.email || null })) });
      toast.success(`${c.name || c.email} added to your contacts`);
      onAdded();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="card-soft mb-6 p-5" data-testid="org-diocese-contacts">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <Church className="h-4 w-4 text-[#1B365D]" />
        <p className="font-semibold text-[#1B365D]">Contacts from the Diocese Charter directory</p>
        {org.inactive && <span className="rounded-full bg-[#F1F5F9] px-2 py-0.5 text-xs font-semibold text-[#64748B]" data-testid="org-diocese-inactive">Inactive · {org.inactive_reason}</span>}
      </div>
      <p className="mb-3 text-xs text-[#64748B]">Kept up to date by the Diocese reviewer{org.dow_contacts_updated_at ? ` (last edited ${String(org.dow_contacts_updated_at).slice(0, 10)})` : ""}. They don't change your contacts; add any you want to use.</p>
      {!org.dow_contacts?.length ? <p className="text-sm text-[#94A3B8]">The Diocese hasn't edited this charter's contacts.</p> : (
        <div className="grid gap-2 sm:grid-cols-2">{org.dow_contacts.map((c: any, i: number) => {
          const have = c.email && ours.has(c.email.toLowerCase());
          return (
            <div key={i} className="flex items-start justify-between gap-3 rounded-lg border border-[#E2E8F0] bg-white p-3 text-sm" data-testid={`org-diocese-contact-${i}`}>
              <div className="min-w-0"><p className="font-semibold">{c.name || "\u2014"}{c.coordinator && <span className="ml-2 rounded-full bg-[#CCFBF1] px-2 py-0.5 text-xs font-semibold text-[#0F766E]" data-testid={`org-diocese-coordinator-${i}`}>Compliance Coordinator</span>}</p><p className="break-all text-xs text-[#475569]">{c.email}</p><p className="text-xs text-[#475569]">{c.phone}</p></div>
              {have ? <span className="flex items-center gap-1 text-xs font-semibold text-[#15803D]"><Check className="h-3.5 w-3.5" /> In your contacts</span>
                : canEdit && <button className="btn-secondary btn-sm whitespace-nowrap" disabled={!!busy} onClick={() => add(c)} data-testid={`org-diocese-contact-add-${i}`}><Plus className="h-4 w-4" /> Add to ours</button>}
            </div>
          );
        })}</div>
      )}
    </div>
  );
}
